import script from "./HeaderAuthAndCurrencyComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderAuthAndCurrencyComponent.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderAuthAndCurrencyComponent.vue?vue&type=style&index=0&id=67f9afe6&lang=css"

const __exports__ = script;

export default __exports__